import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import * as Model from '../../model/lottomart-model';

@Component({
  selector: 'app-form-field-lotto-line',
  templateUrl: './lotto-line-form-field.component.html',
  styleUrls: ['lotto-line-form-field.component.scss'],
  standalone: false,
})
export class LottoLineFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  @Input() tableMode = false;

  allSelectionsLength = 0;

  hoverMode = false;

  ngOnInit() {
    if (this.data) {
      this.allSelectionsLength = this.data.flatMap((s) => s.picked).length;
    }
  }

  ngOnDestroy() {}
}
